import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';
import funzoneLogo from '../../../assets/logos/funzone.webp';
import funzoneLogoLight from '../../../assets/logos/funzone_lightmode.webp';

const FunZoneLogo = ({ className, style }) => {
  const theme = useTheme();
  const glow =
    theme.palette.mode === 'light'
      ? alpha(theme.palette.primary.main, 0.22)
      : alpha(theme.palette.warning.main, 0.4);
  const logoSrc = theme.palette.mode === 'light' ? funzoneLogoLight : funzoneLogo;
  return (
    <Link to='/' style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
      <Box
        component='img'
        src={logoSrc}
        alt='Logo FunZone Erlebniswelten'
        className={className}
        sx={{
          width: '100%',
          maxWidth: '400px',
          minWidth: '100px',
          display: 'block',
          margin: '10px auto',
          filter: `drop-shadow(16px 16px 16px ${glow})`,
          ...style,
        }}
        loading='lazy'
      />
    </Link>
  );
};

export default FunZoneLogo;
